import React, { useCallback, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFolderOpen } from '@fortawesome/pro-light-svg-icons/faFolderOpen';
import { TypedMemo } from '../../../../../common/types';
import { SMLButton } from '../../../../components/primitives/SMLButton';
import { allFilesMessages } from './allFilesMessages';
import { AllFilesDialog } from './AllFilesDialog';

interface AllFilesButtonProps {
  accountId: number;
  songTitles: string[];
}

/** "All files" on the Releases header, and ⌘K / Ctrl+K (design assets-rethink d1, d4). */
const AllFilesButtonComponent: React.FC<AllFilesButtonProps> = ({ accountId, songTitles }) => {
  const intl = useIntl();
  const [isOpen, setIsOpen] = useState(false);
  const close = useCallback(() => setIsOpen(false), []);

  useEffect(() => {
    const onKey = (event: KeyboardEvent): void => {
      if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'k') {
        event.preventDefault();
        setIsOpen(true);
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  return (
    <>
      <SMLButton
        onClick={() => setIsOpen(true)}
        icon={<FontAwesomeIcon icon={faFolderOpen} />}
        title={intl.formatMessage(allFilesMessages.shortcut)}
      >
        {intl.formatMessage(allFilesMessages.open)}
      </SMLButton>
      {isOpen && <AllFilesDialog accountId={accountId} isOpen={isOpen} songTitles={songTitles} onClose={close} />}
    </>
  );
};

export const AllFilesButton = TypedMemo(AllFilesButtonComponent);
